export var apiServices = {
    poller: Symbol('Poller'),
    videoMakerBaseUrl: Symbol('videoMakerBaseUrl'),
    videoMakerApi: Symbol('videoMakerApi'),
    videoMakerJobQueue: Symbol('videoMakerJobQueue'),
};
//# sourceMappingURL=services.js.map